import {compose} from 'ramda'
import {filterKV} from 'app/utils/f'

export function hasProperties(x) {
    for(var prop in x) {
        if(Object.prototype.hasOwnProperty.call(x, prop)) {
              return true
        }
    }

    return false
}

// Gets values from an object that are numerically keyed (e.g. keys 1, 2, '1', '400')
// and returns those values as an array. Does not preserve keys. Useful for getting
// items from an object that was created in PHP from an array like ['a', 'b', 'list' => ['q', 'd']].
// In that example, this function would return ['a', 'b']. If the value provided is
// already an array, just returns the array.
export function getNumericallyKeyedValues(xs) {
    return Array.isArray(xs)
        ? xs
        : compose(
            Object.values, // convert to array
            filterKV((v, k) => !isNaN(k)) // only get items with numeric keys
        )(xs)
}

export function isObject(x) {
    return (typeof x === "object") && (x !== null)
}



// WEBPACK FOOTER //
// ./react/utils/objects.js